<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" width="200px">
      <v-card>
        <div class="container">
          <p>Cargando</p>
          <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data: () => ({
    value: false,
  })
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100px;
}
</style>
